import React from 'react'
import { Box, Grid, Theme, Typography, useMediaQuery } from '@mui/material'

import { getAppTheme } from '../../../../shared/config/getAppTheme'
import getDataGeography from '../getDataGeography'
import DOMPurify from 'dompurify'

const Leipzig: React.FC = () => {
  const theme: Theme = getAppTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <>
      <Typography variant='h1'>Garnison Leipzig</Typography>
      <Typography variant='subtitle1'>Vorgeschichte</Typography>
      <Grid container spacing={2}>
        <Grid item xs={downMd ? 12 : 8} sx={{ display: 'flex', alignItems: 'flex-start' }}>
          <Typography
            variant='body1'
            dangerouslySetInnerHTML={{ __html: `${DOMPurify.sanitize(getDataGeography('leipzig')[0] as string)}` }}
          />
        </Grid>
        <Grid item container xs={downMd ? 12 : 4} sx={{ display: 'flex', alignItems: 'flex-start' }}>
          <Grid item xs={12}>
            <img src='/images/pleißenburg1780.jpg' style={{ width: '100%' }} />
            <Typography variant='caption'>Hauer, Daniel Adam: Das Schloß oder Castell zu Leipzig, die
              Pleißenburg
              genannt
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Typography variant='subtitle1'>Geschichte</Typography>
      <Grid container spacing={2}>
        <Grid item xs={downMd ? 12 : 8} sx={{ display: 'flex', alignItems: 'flex-start' }}>
          <Typography
            variant='body1'
            dangerouslySetInnerHTML={{ __html: `${DOMPurify.sanitize(getDataGeography('leipzig')[1] as string)}` }}
          />
        </Grid>
        <Grid item container xs={downMd ? 12 : 4} sx={{ display: 'flex', alignItems: 'flex-start' }}>
          <Grid item xs={12}>
            <img src='/images/Leipzig1911.jpg' style={{ width: '100%' }} />
            <Typography variant='caption'>Brück & Sohn Kunstverlag Meißen</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Box sx={{ marginTop: '20px' }}>
        <img src='/images/garnisionskarteLeipzig.jpg' style={{ width: '100%' }} />
        <Typography variant='caption'>Stadtgeschichtliches Museum Leipzig Haus Böttchergäßchen</Typography>
      </Box>
    </>
  )
}

export default Leipzig
